const TermsConditions = () => {
  return (
    <div className="max-w-5xl mx-auto px-6 py-20 mt-10">

      <h1 className="text-3xl md:text-4xl font-semibold mb-8 text-center">
        Terms & Conditions
      </h1>

      <div className="space-y-6 text-gray-700 leading-relaxed">

        <p>
          Welcome to our website. By accessing or purchasing from our website,
          you agree to comply with and be bound by the following Terms & Conditions.
        </p>

        <div>
          <h2 className="text-xl font-medium mb-2">1. Use of Website</h2>
          <p>
            You agree to use this website for lawful purposes only.
            Any misuse, fraud, or unauthorized activity is strictly prohibited.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-medium mb-2">2. Product Information</h2>
          <p>
            We strive to ensure that product descriptions, prices, and images
            are accurate. However, we reserve the right to correct any errors
            and update information without prior notice.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-medium mb-2">3. Pricing & Payments</h2>
          <p>
            All prices are listed in INR. We reserve the right to change prices
            at any time without prior notice.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-medium mb-2">4. Orders & Cancellation</h2>
          <p>
            We reserve the right to cancel or refuse any order if fraudulent
            activity is suspected or product is unavailable.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-medium mb-2">5. Returns & Refunds</h2>
          <p>
            Please refer to our Return Policy page for detailed information
            regarding returns and refunds.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-medium mb-2">6. Limitation of Liability</h2>
          <p>
            We are not responsible for any indirect, incidental, or
            consequential damages arising from the use of our website.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-medium mb-2">7. Changes to Terms</h2>
          <p>
            We reserve the right to update or modify these Terms & Conditions
            at any time without prior notice.
          </p>
        </div>

      </div>
    </div>
  );
};

export default TermsConditions;